import { trackComponent } from "@repo/analytics";
import {
  componentNameConstants,
  dlEventConstants,
} from "@repo/analytics/data-layer.constants";
import type { BFLApiFailureRetryClickParams } from "@repo/shared-ui/BFLApiFailure";

export async function trackFailureScenarioRetryClick(
  params: BFLApiFailureRetryClickParams,
  getCustomerId?: () => Promise<string | undefined>
): Promise<void> {
  const customerId = await getCustomerId?.();
  await trackComponent({
    componentName: componentNameConstants.FAILURE_SCENARIOS,
    sectionTitle: params.sectionTitle,
    eventType: dlEventConstants.CLICK,
    clickType: dlEventConstants.FAILURE_SCENARIOS_BUTTON_CLICK,
    ctaText: params.ctaText,
    productCategory: params.productCategory,
    subSection: params.subSection,
    segmentName: params.segmentName,
    componentPosition: params.componentPosition,
    cleverTapOverrides: {
      EP_PROPERTY_TYPE: "plp",
      EP_EVENT_TYPE: "click",
      EP_ENTRYPOINT: params.entryPoint ?? "no_result_found",
      EP_PAGE_NAME: "stock news",
      ...(params.subSection && { EP_PRODUCT_NAME: params.subSection }),
      ...(params.productCategory && {
        EP_PRODUCT_CATEGORY: params.productCategory,
      }),
      ...(params.componentPosition && {
        EP_SR_NUMBER: params.componentPosition,
      }),
      ...(params.segmentName && { EP_SEGMENT: params.segmentName }),
      ...(params.journeyTag && { EP_JOURNEY: params.journeyTag }),
      ...(params.campaignName && { EP_CAMPAIGN: params.campaignName }),
      ...(params.sprint && { EP_SPRINT: params.sprint }),
      ...(params.referenceId && { EP_REFERENCE_ID: params.referenceId }),
      ...((params.customerId ?? customerId) && {
        EP_CUSTOMER_ID: params.customerId ?? customerId,
      }),
    },
  });
}
